import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import Request from "../../../helpers/request";
import * as url from "../../../helpers/url_helper";
import { toast } from "react-toastify";

interface RefreshSegmentProps {
  isOpen: boolean;
  toggle: () => void;
  segmentData: {
    id?: string;
    _id?: string;
    name: string;
    description: string;
  } | null;
  onRefreshSuccess: () => void;
}

const RefreshSegment: React.FC<RefreshSegmentProps> = ({
  isOpen,
  toggle,
  segmentData,
  onRefreshSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const handleRefresh = async () => {
    if ( !segmentData?._id) {
      toast.error("Segment ID is required");
      return;
    }

    setLoading(true);
    try {
      const response = await Request.post(
        `${url.BASE_URL}${url.REFRESH_FILTER_SEGMENT}`,
        {
          segmentId: segmentData._id,
        }
      );

      if (response.status === 200) {
        toast.success("Segment refreshed successfully");
        onRefreshSuccess();
        toggle();
      }
    } catch (error: any) {
      console.error("Error refreshing segment:", error);
      if (error?.response?.status === 401) {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("selectedPremiseID");
        localStorage.removeItem("selectedUserID");
        localStorage.removeItem("selectedUserEmail");
        localStorage.removeItem("Authorization");
        localStorage.removeItem("permissions");
        window.location.reload();
      } else {
        toast.error(
          error?.response?.data?.message || "Failed to refresh segment"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Refresh Segment</ModalHeader>
      <ModalBody>
        <div className="text-center">
          <div className="mb-3">
            <box-icon name="refresh" size="48px" color="#007bff"></box-icon>
          </div>
          <h5>Refresh Segment Data</h5>
          <p className="text-muted mb-0">
            This will refresh the user data for segment{" "}
            <strong>{segmentData?.name}</strong> based on the current filters.
            This action may take some time to complete.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="btn btn-dark"
          size="sm"
          onClick={toggle}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          className="btn btn-dark"
          size="sm"
          onClick={handleRefresh}
          disabled={loading}
        >
          {loading && (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          )}
          Refresh Segment
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RefreshSegment;
